<ng-container *ngIf="!showAddNewAddressForm && (addresses$ | async) as addresses">
  <div class="mb-checkout-shipping-address"
       data-cy="mb-checkout-shipping-address">

    <div class="row no-gutters mb-3 text-left mb-checkout-headline"
         data-cy="mb-checkout-shipping-section">
      {{ 'address.shippingAddressHeadline' | cxTranslate }}
    </div>
    <div class="row">
      <div class="col-12 col-md-6" *ngFor="let address of addresses">
        <mb-address-tile [address]="address"
                          [isSelectedAddress]="selectedAddress?.id === address?.id"
                          [formRegion]="checkoutRegion"
                          [showSelectionRadiobox]="address?.verificationStatus !== constants.ADDRESS_VERIFIED_REJECTED_STATUS_04"
                          (addressSelected)="addressSelectedHandler($event)">
        </mb-address-tile>
      </div>
      <div class="col-12 col-md-6">
        <mb-checkout-new-address-tile (addNewAddress)="toggleShowAddNewAddressForm()"></mb-checkout-new-address-tile>
      </div>
    </div>

    <div class="row no-gutters mt-4">
      <div class="col-12 col-md mr-4 mt-2 order-2 order-md-1">
        <button class="btn btn-block btn-secondary mb-buttons"
                data-cy="mb-checkout-shipping-address-back-btn"
                type="button"
                (click)="back()">
          {{ 'navigationPage.backBtn' | cxTranslate }}
        </button>
      </div>
      <div class="col-12 col-md mt-2 order-1 order-md-2">
        <button data-cy="mb-checkout-shipping-address-next-btn"
                class="btn btn-block btn-primary mb-buttons"
                type="button"
                mbOneClickAllowed
                (click)="next()">
          {{ 'navigationPage.nextBtn' | cxTranslate }}
        </button>
      </div>
    </div>

  </div>
</ng-container>
